import { useSelector } from '@xstate/react';

import { useEssentialMachines } from '../../EssentialMachines';

// ─────────────────────────────────────────────────────────────────────────────

export const useSessionRetryAt = () => {
  const { authMachineRef } = useEssentialMachines();

  return useSelector(authMachineRef, (state) => state.context.sessionRetryAt);
};
